import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	BankucetId: null as number | null,
	DokladDruh: null as string | null,
	DokladSk: null as number | null,
	DokladZao: null as number | null,
	DokladcrId: null as number | null,
	DphvypocPrp: null as boolean | null,
	PredmetTxt: null as string | null,
	Text: null as string | null,
	Vodotisk: null as string | null,
	ZahlaviElektron: null as string | null,
	ZahlaviKopie: null as string | null,
	ZahlaviOrig: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		DokladSk: [],
		BankucetId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
